import styled, { css } from 'styled-components';
import { rem } from 'polished';
var Main = styled.div.withConfig({
  displayName: "Main",
  componentId: "sc-15nq7q-0"
})(["position:relative;", ";"], function (_ref) {
  var scrollButton = _ref.scrollButton,
      btnWidth = _ref.btnWidth;
  return scrollButton && css(["padding:0 ", ";"], rem(btnWidth));
});
export default Main;